export default {
    about_doctor: "Дарыгер жөнүндө",
    account_manager: "Аккаунт менеджер",
    activated: "Жандырылды",
    additional_info: "Дополнительная информация",
    administrator: "Администратор",
    administrators: "Администраторлор",
    amount_of_doctors: "Дарыгерлердин саны",
    are_you_sure_you_want_to_delete_field: "Багытты чындыгында жок кылгыңыз келеби?",
    assistants: "Жардамчылар",
    backup_code: "Камдык код",
    block: "Бөгөттөө",
    block_noun: "Бөгөт",
    browse_computer: "Файлдардан тандаңыз",
    by_cabinets: "Офис боюнча",
    by_days: "Күн боюнча",
    by_days_of_week: "Жуманын күндөрү боюнча",
    by_even_days: "Жуп күндөрдө",
    by_odd_days: "Жуп эмес күндөрдө",
    cabinet: "Кабинет",
    cabinets: "Кабинеттер",
    chair: "Кресло",
    chairs: "Креслолор",
    clinic_access_request: "Клиникага кирүү өтүнмөсү",
    config: "Конфигурация",
    confirm_password: "Жашырынсөздү кайталоо",
    curator: "Куратор",
    curators: "Кураторлор",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Dentist+ техникалык колдоо кызматы Сиздин клиникаңызга кирүүнү суранат",
    doctor_position: "Дарыгердин орду",
    doctor_specialty: "Дарыгер адистиги",
    enter_backup_code_note: "Эки факторлуу аутентификацияны иштеткенде сиз алган камдык коддордун бирин киргизиңиз. Ар бир резервдик код бир гана жолу колдонулушу мүмкүн экенин эске алыңыз",
    enter_code_from_authorization_app: "Телефонуңуздагы эки факторлуу аутентификация колдонмосунан кодду киргизиңиз",
    field: "Багыт",
    fields: "Багыттар",
    functionality: "Функционал",
    login_and_password: "Логин и жашырынсөз",
    manual_pay_system: "Кол менен төлөм системасы",
    not_worked: "Иштелген эмес",
    partner: "Өнөктөш",
    password_does_not_match_confirmation: "Жашырынсөз тастыктоо менен дал келбейт",
    password_requirement_min_length: "Кеминде {min} белги",
    password_requirement_mixed_case: "Латын тамгалары чоң жана кичине түрдө",
    password_requirement_number: "Сан милдеттүү",
    password_requirement_symbol: "Атайын белги милдеттүү",
    percent: "Пайыз",
    period_from: "Мезгил  баштап",
    period_to: "Мезгил  чейин",
    phone2: "Телефон 2",
    profession: "Адистик",
    rate: "Чен",
    rate_per_day: "Күнүмдүк чен",
    rate_per_hour: "Сааттык чен",
    rate_per_month: "Айлык чен",
    reserve_codes: "Резервдик коддор",
    roles: "Ролдор",
    sale_good_percent: "Товарларды сатуудан алынган пайыз",
    schedule_conflicts_found: "Учурдагы жазылуулар менен ырааттама боюнча табылган чыр-чатактар",
    seller: "Сатуучу",
    staff: "Персонал",
    take_photo: "Сүрөткө түшүү",
    technics: "Техниктер",
    turn_on: "Күйгүзүү",
    turned_off: "Өчүрүлгөн",
    two_factor_authorization: "Эки факторлуу аутентификация",
    two_factor_authorization_setup_successfully: "Эки факторлуу аутентификация ийгиликтүү жандырылды",
    twofactor_setup_instructions: "<ul><li>Колдонмолор дүкөнүнөн же Google Play'ден аныктыгын текшерүүчү колдонмону (мисалы, Google Authenticator, Microsoft Authenticator, Yandex.Key) жүктөп алыңыз.</li><li>Телефонуңуздагы колдонмодон \"Код кошуу\"/'+' баскычын таптап, компьютериңиздин экранында көрсөтүлгөн QR кодун сканерлеңиз.</li><li>Төмөнкү 6 орундуу QR кодун түзүү үчүн колдонмонун 6 орундуу кодун түзүү үчүн төмөнкү талаага киргизиңиз. байланыштар</li><li>Телефонуңузду жоготуп алсаңыз, сунушталган резервдик коддорду (6 орундуу кодду текшергенден кийин пайда болот) коопсуз жерге сактап коюңуз</li></ul>",
    use_app_code: "Стандарттык кодду колдонуңуз",
    use_backup_code: "Камдык кодду колдонуңуз",
    user_data: "Колдонуучу тууралуу маалымат",
    user_will_assigned_rights_selected_for_that_role: "Колдонуучуга бул роль үчүн тандалган укуктар ыйгарылат",
    weekend: "ЖДем алыш",
    without_warehouse_form_note: "Склад менен байланыштырылбастан, материалдар негизги складдан же кресло менен байланышкан складдан эсептен чыгарылат",
    work_day: "Жумуш күнү",
    work_days: "Жумуш күндөрү",
    work_schedule: "Иш графиги",
    work_time: "Иштөө убактысы",
    worked: "Иштетилген"
}
